import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import { getInitials, getUsername } from "../utils/utils";

export default function AbgAvatar() {
  const[username, setUsername] = useState(getUsername());
  const[initials, setInitials] = useState(getInitials());

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title = {username}>
        <Avatar
          sx={{
            bgcolor: "#72A0C1",
            color: "black",
            width: 40,
            height: 40,
            fontSize: "16px",
          }}
        >
          {initials}
        </Avatar>
      </Tooltip>
    </Box>
  )
}
